export const Breakpoints = {
    XXS: {min: 0, max: 480, name: 'xxs'},
    XS: {min: 481, max: 767, name: 'xs'},
    SM: {min: 768, max: 991, name: 'sm'},
    MD: {min: 992, max: 1099, name: 'md'},
    LG: {min: 1100, max: 1499, name: 'lg'},
    XLG: {min: 1500, max: null, name: 'xlg'},
};